const getAllDataForIntermediary = ({ db, currentUser, referralId }) => {
    return new Promise(async (resolve, reject) => {
        try {
            const user = await db.get({ path: `users/${currentUser.uid}` });
            const path = `intermediaries/${user.uid}/referrals/${referralId}`;

            const request = await db.get({ path });

            if (!request) throw new Error(`request ${referralId} not found`);

            const referral = await db.get({ path: request.referralPath });

            if (!referral) throw new Error(`referral not found at ${request.referralPath}`)

            const referrer = await db.get({ path: `users/${referral.uid}` });

            const intermediary = await db.get({ path: `intermediaries/${currentUser.uid}` });

            intermediary.profile.email = intermediary.profile.email || currentUser.email;
            intermediary.profile.title = intermediary.profile.title || user.name;

            const notes = await db.get({ path: `organizations/${referral.organizationId}/notes/${referralId}` });
            const courtCase = await db.get({ path: `organizations/${referral.organizationId}/cases/${referral.courtCaseId}` });

            resolve({
                request,
                referral,
                referrer,
                user,
                intermediary,
                notes,
                courtCase
            });

        }
        catch (error) {
            console.log(error);
            reject(error);
        }
    })
}

const getAllDataForReferrer = ({ db, currentUser, referralId, intermediaryId }) => {
    return new Promise(async (resolve, reject) => {
        try {
            const user = await db.get({ path: `users/${currentUser.uid}` });
            const path = `organizations/${user.organization}/referrals/${referralId}`;
            const referral = await db.get({ path });

            if (!referral) throw new Error(`referral not found at ${path}`)

            const organization = await db.get({ path: `organizations/${referral.organizationId}` });
            const referrer = await db.get({ path: `users/${referral.uid}` });
            const notes = await db.get({ path: `organizations/${referral.organizationId}/notes/${referralId}` });
            const courtCase = await db.get({ path: `organizations/${referral.organizationId}/cases/${referral.courtCaseId}` });
            const intermediary = await db.get({ path: `intermediaries/${intermediaryId}` });

            resolve({
                referral,
                referrer,
                organization,
                user,
                notes,
                courtCase,
                intermediary
            });

        }
        catch (error) {
            console.log(error);
            reject(error);
        }
    })
}


export {
    getAllDataForIntermediary,
    getAllDataForReferrer
}